import { bind } from 'bind-event-listener';
const timings = [];
let wasHiddenFlag;
let setupFlag = false;
function isPageHidden() {
  if ('visibilityState' in document) {
    return document.visibilityState === 'hidden';
  } else {
    // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
  }
}
const SIZE = 50;
let insertIndex = 0;
function pushHidden(isPageHiddenFlag, time) {
  timings[insertIndex] = {
    time: time !== null && time !== void 0 ? time : performance.now(),
    hidden: isPageHiddenFlag
  };
  insertIndex = (insertIndex + 1) % SIZE;
  wasHiddenFlag = isPageHiddenFlag;
}
function handleChange() {
  const isPageHiddenFlag = isPageHidden();
  if (isPageHiddenFlag) {
    if (!wasHiddenFlag) {
      pushHidden(isPageHiddenFlag);
    }
    wasHiddenFlag = true;
  } else {
    if (wasHiddenFlag) {
      pushHidden(isPageHiddenFlag);
    }
    wasHiddenFlag = false;
  }
}
function setup() {
  bind(window, {
    type: 'pageshow',
    listener: handleChange
  });
  bind(window, {
    type: 'pagehide',
    listener: handleChange
  });
  bind(document, {
    type: 'visibilitychange',
    listener: handleChange
  });
}
export function setupHiddenTimingCapture() {
  if (!setupFlag) {
    const isPageHiddenFlag = isPageHidden();
    pushHidden(isPageHiddenFlag, 0);
    setup();
    setupFlag = true;
  }
}
export function getPageVisibilityState(start, end) {
  // Desirable default value is visible
  if (timings.length === 0) {
    return 'visible';
  }
  const currentSize = timings.length;
  let hiddenState = 'mixed';
  let startIdx = insertIndex;
  let endIdx = insertIndex;

  // currentSize is capped at SIZE.
  for (let i = 0; i < currentSize; i++) {
    const tmpIdx = (insertIndex + i) % currentSize;
    if (timings[tmpIdx].time <= end) {
      endIdx = tmpIdx;
      if (timings[tmpIdx].time <= start) {
        startIdx = tmpIdx;
      }
    }
  }
  if (endIdx - startIdx === 0) {
    if (timings[startIdx].hidden) {
      hiddenState = 'hidden';
    } else {
      hiddenState = 'visible';
    }
  }
  return hiddenState;
}